<div class="footer bg-light text-dark py-5">
  <div class="container">
    <!-- Footer Columns -->
    <div
      class="footer-row d-flex flex-wrap justify-content-between text-center text-md-start mb-4"
    >
      <!-- Column 1 -->
      <div class="footer-col col-12 col-md-auto mb-3 mb-md-0 text-md-start">
        <h4 class="footer-title">Maltech</h4>
        <ul class="list-unstyled">
          <li><a routerLink="/home" href="/home" aria-label="Go to Home" title="Home">Home</a></li>
          <li><a routerLink="about/" href="about/" aria-label="Learn more About Us" title="About Us">About Us</a></li>
          <li><a routerLink="careers" href="careers" aria-label="View Careers" title="Careers">Careers</a></li>
          <li><a routerLink="portfolio" href="portfolio" aria-label="View Portfolio" title="Portfolio">Portfolio</a></li>
        </ul>
      </div>

      <!-- Column 2 -->
      <div class="footer-col col-12 col-md-auto mb-3 mb-md-0 text-md-start">
        <h4 class="footer-title">Services</h4>
        <ul class="list-unstyled">
          <li>
            <a routerLink="service/software-development/" href="service/software-development/" aria-label="Learn about Software Development services" title="Software Development">Software Development</a>
          </li>
          <li>
            <a routerLink="service/software-consulting-services/" href="service/software-consulting-services/" aria-label="Learn about Software Consulting Services" title="Software Consulting Services">Software Consulting Services</a>
          </li>
          <li>
            <a routerLink="service/ai/" href="service/ai/" aria-label="Explore Artificial Intelligence services" title="Artificial Intelligence">Artificial Intelligence</a>
          </li>
          <li>
            <a routerLink="service/quantum-computing/" href="service/quantum-computing/" aria-label="Explore Quantum Computing services" title="Quantum Computing">Quantum Computing</a>
          </li>
          <li>
            <a routerLink="service/ux-design/" href="service/ux-design/" aria-label="Learn about UX Design services" title="UX Design">UX Design</a>
          </li>
          <li>
            <a routerLink="service/digital-marketing/" href="service/digital-marketing/" aria-label="Explore Digital Marketing services" title="Digital Marketing">Digital Marketing</a>
          </li>
        </ul>
      </div>

      <!-- Column 3 -->
      <div class="footer-col col-12 col-md-auto mb-3 mb-md-0 text-md-start">
        <h4 class="footer-title">Products</h4>
        <ul class="list-unstyled">
          <li>
            <a routerLink="product/transactional-emails/" href="product/transactional-emails/" aria-label="Explore Transactional Emails product" title="Transactional Emails">Transactional Emails</a>
          </li>
          <li>
            <a routerLink="product/email-verifier/" href="product/email-verifier/" aria-label="Explore Email Verification product" title="Email Verification">Email Verification</a>
          </li>
          <li>
            <a routerLink="product/whatsapp-apis/" href="product/whatsapp-apis/" aria-label="Explore WhatsApp APIs product" title="WhatsApp APIs">WhatsApp APIs</a>
          </li>
        </ul>
      </div>

      <!-- Column 4 -->
      <div class="footer-col col-12 col-md-auto mb-3 mb-md-0 text-md-start">
        <h4 class="footer-title">Resources</h4>
        <ul class="list-unstyled">
          <li><a  [href]="blogUrl" aria-label="Read our Blog" title="Blog">Blog</a></li>
          <li><a routerLink="/resource/branding/" href="/resource/branding/" aria-label="View Branding Resources" title="Branding">Branding</a></li>
        </ul>
      </div>

      <!-- Column 5 -->
      <div class="footer-col col-12 col-md-auto mb-3 mb-md-0 text-md-start">
        <h4 class="footer-title">Contact</h4>
        <div class="d-flex gap-2 justify-content-center flex-wrap">
          <a
            href="https://www.linkedin.com/company/maltechs/"
            target="_blank"
            rel="noopener noreferrer"
            class="social-icon linkedin"
            aria-label="Connect with us on LinkedIn (opens in a new window)"
            title="Visit our LinkedIn (opens in a new window)"
            ><i class="bi bi-linkedin"></i
          ></a>
          <a
            href="https://x.com/MAL_techs"
            target="_blank"
            class="social-icon twitter"
            rel="noopener noreferrer"
            aria-label="Follow us on X (opens in a new window)"
            title="Follow us on X (opens in a new window)"
            ><i class="bi bi-twitter"></i
          ></a>
          <a
            href="https://www.facebook.com/MALtechs"
            target="_blank"
            class="social-icon facebook"
            rel="noopener noreferrer"
            aria-label="Follow us on Facebook (opens in a new window)"
            title="Visit our Facebook (opens in a new window)"
            ><i class="bi bi-facebook"></i
          ></a>
          <a
            href="https://www.instagram.com/maltechs/"
            target="_blank"
            class="social-icon instagram"
            rel="noopener noreferrer"
            aria-label="Follow us on Instagram (opens in a new window)"
            title="Follow us on Instagram (opens in a new window)"
            ><i class="bi bi-instagram"></i
          ></a>
          <a
            href="https://www.youtube.com/channel/UC0EKhFVtvSdG_MCZAnr4jTA"
            target="_blank"
            aria-label="Follow us on YouTube (opens in a new window)"
            class="social-icon youtube"
            rel="noopener noreferrer"
            title="Visit our YouTube channel (opens in a new window)"
            ><i class="bi bi-youtube"></i
          ></a>
        </div>
      </div>
    </div>

    <!-- Logo -->
    <div class="footer-logo text-center my-4">
      <a routerLink="/home" href="/home" aria-label="Go to Maltech homepage" title="Maltech Homepage">
        <img
  src="/assets/images/footer/logo-252.webp"
  srcset="
    /assets/images/footer/logo-252.webp 252w,
    /assets/images/footer/logo-504.webp 504w
  "
  sizes="252px"
  alt="MALtech company logo"
  width="252"
  height="80"
/>
      </a>
    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <div
        class="container d-flex flex-column flex-md-row justify-content-between align-items-center"
      >
        <p class="mb-2 mb-md-0">© MALtech. All rights reserved.</p>
        <div
          class="policy-links d-flex gap-4 flex-wrap justify-content-center justify-content-md-end"
        >
          <a routerLink="/terms-and-conditions" href="/terms-and-conditions" aria-label="View Terms of Service" title="Terms Of Service">Terms Of Service</a>
          <a routerLink="/privacy-policy" href="/privacy-policy" aria-label="View Privacy Policy" title="Privacy Policy">Privacy Policy</a>
          <a routerLink="/refund-policy" href="/refund-policy" aria-label="View Refund Policy" title="Refund Policy">Refund Policy</a>
        </div>
      </div>
    </div>
  </div>
</div>
